import React, { useEffect, useState } from 'react'
import { Button, Input, message, Modal, Select, Table } from 'antd'
import { getEstimateFieldByProject } from '../../services/estimate-field'
import usePagination from '../hooks/usePagination'
import Highlighter from 'react-highlight-words'
import styles from '../../screens/Estimate/style.module.css'
import useCategory from '../hooks/useCategory'

const { Search } = Input

const EstimateSuggestion = ({ isModalOpen, project, onUpdate, handleCancel }) => {
  const [categories] = useCategory(project)
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [paginationTotal, setPaginationTotal] = useState(0)
  const [tablePagination, page, pageSize, setPage] = usePagination(paginationTotal)
  const [selectedCategories, setSelectedCategories] = useState([])

  const getData = async () => {
    const response = await getEstimateFieldByProject(project, searchValue, selectedCategories, { page, pageSize })
    if (response && response.status === 200 && response.data) {
      setData(response.data?.data?.attributes?.results)
      setPaginationTotal(response.data?.data?.attributes?.pagination?.total)
    }
  }

  const updateData = () => {
    setIsLoading(true)
    getData()
      .catch(() => message.error('Ошибка загрузки контента'))
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    if (isModalOpen) {
      updateData()
    }
  }, [isModalOpen, project, searchValue, selectedCategories, page, pageSize])

  const onSearchChange = (e) => {
    setSearchValue(e.target.value)
    setPage(1)
  }

  const onCategoriesChange = (values) => {
    setSelectedCategories(values)
  }

  const columns = [
    {
      title: '№',
      dataIndex: 'id',
    },
    {
      title: 'Наименование',
      dataIndex: 'name',
      render: (name) => <Highlighter searchWords={searchValue.split(' ')} autoEscape textToHighlight={name} />,
    },
    {
      title: 'Цена',
      dataIndex: 'price',
    },
    {
      title: 'Кол-во',
      dataIndex: 'amount',
    },
    {
      title: 'Ед. Изм.',
      dataIndex: 'unit',
    },
    {
      title: 'Категория',
      dataIndex: 'category',
    },
    {
      title: 'Действия',
      dataIndex: 'actions',
      render: (_, record) => {
        return (
          <div>
            <Button
              type="link"
              onClick={() => {
                onUpdate(record)
                handleCancelCallback()
              }}
            >
              Выбрать
            </Button>
          </div>
        )
      },
    },
  ]

  const handleCancelCallback = () => {
    handleCancel()
    setSearchValue('')
    setSelectedCategories([])
  }

  return (
    <Modal
      width={1300}
      title="Выбор позиции из сметы"
      visible={isModalOpen}
      onCancel={handleCancelCallback}
      footer={null}
    >
      <div className={styles.search}>
        <Search
          style={{ flex: 1 }}
          allowClear
          placeholder="Введите название позиции"
          onChange={onSearchChange}
          loading={isLoading}
          value={searchValue}
        />
        <Select
          style={{ flex: 1, marginLeft: 15 }}
          mode="multiple"
          allowClear
          options={categories.map((category) => ({
            value: category,
            label: category,
          }))}
          placeholder="Выберите категорию"
          dropdownMatchSelectWidth={false}
          onChange={onCategoriesChange}
        />
      </div>
      <Table
        style={{ paddingTop: 20, cursor: 'pointer' }}
        size="small"
        columns={columns}
        dataSource={data}
        pagination={tablePagination}
      />
    </Modal>
  )
}

export default EstimateSuggestion
